import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "location_pin",
  "use": "location_pin-usage",
  "viewBox": "0 0 32 47",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 47\" id=\"location_pin\"><path d=\"M16 0c8.836 0 16 7.014 16 15.667 0 7.116-10.825 24.962-14.667 30.633a1.622 1.622 0 01-2.666 0C10.825 40.629 0 22.783 0 15.667 0 7.014 7.164 0 16 0zm0 7.833c-4.418 0-8 3.507-8 7.834 0 4.326 3.582 7.833 8 7.833s8-3.507 8-7.833c0-4.327-3.582-7.834-8-7.834z\" fill=\"#000\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol